import React from "react";
import Slider from "react-slick";

function TestimonialItem({ imgSrc, quote, name, position }) {
  return (
    <div className="single-testimonial-outer">
      <div className="single-testimonial">
        <div className="qt-img">
          <img src="/assets/img/testimonial/qt-icon.png" alt="img" />
        </div>
        <p>{quote}</p>
        <div className="testi-author">
          <img src={imgSrc} alt="img" />
          <div className="ta-info">
            <h6>{name}</h6>
            <span>{position}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Testimonial() {
  const settings = {
    dots: true,
    arrows: false,
    prevArrow:
      '<button type="button" className="slick-prev"><i className="fas fa-arrow-left"></i></button>',
    nextArrow:
      '<button type="button" className="slick-next"><i className="fas fa-arrow-right"></i></button>',
    speed: 1000,
    slidestoshow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidestoshow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidestoshow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidestoshow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      imgSrc: "assets/img/testimonial/testi_avatar.png",
      quote:
        "“Anjanadri Institute of Pharmacy provides excellent laboratory facilities and supportive faculty. The practical training helped me gain confidence and prepare for my career in the pharmaceutical industry.”",
      name: "Rahul Kumar",
      position: "B.Pharm Student",
    },
    {
      imgSrc: "assets/img/testimonial/testi_avatar.png",
      quote:
        "“The campus environment is very encouraging, and the teachers are always ready to guide students. I am proud to be part of an institute that focuses on both academics and professional development.”",
      name: "Priya Sharma",
      position: "Final Year Student",
    },
    {
      imgSrc: "assets/img/testimonial/testi_avatar.png",
      quote:
        "“My child has gained strong knowledge and practical skills through the B.Pharm program. The faculty members are dedicated, and the facilities are well maintained. I highly recommend this college.”",
      name: "Suresh Reddy",
      position: "Parent",
    },
    {
      imgSrc: "assets/img/testimonial/testi_avatar.png",
      quote:
        "“The institute offers modern laboratories and industry-focused learning. The practical sessions and guidance from faculty helped me understand pharmaceutical concepts clearly.”",
      name: "Anjali Verma",
      position: "B.Pharm Student",
    },
    {
      imgSrc: "assets/img/testimonial/testi_avatar.png",
      quote:
        "“Anjanadri Institute of Pharmacy maintains a disciplined academic environment and provides quality education. The faculty members are experienced and supportive.”",
      name: "Dr. Ramesh Kumar",
      position: "Healthcare Professional",
    },
  ];

  return (
    <>
      <section
        className="testimonial-area text-center pt-120 pb-120"
        style={{
          background: "url(assets/img/bg/testimonial-bg.png) no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <Slider
                className="testimonial-active2 wow fadeInUp  animated"
                data-animation="fadeInUp"
                data-delay=".4s"
                {...settings}
              >
                {testimonials.map(({ imgSrc, quote, name, position }) => (
                  <TestimonialItem
                    key={name}
                    imgSrc={imgSrc}
                    quote={quote}
                    name={name}
                    position={position}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonial;
